import { Button, Stack } from '@mui/material';
import { SparkleIcon } from '@phosphor-icons/react';
import { Link as ReactRouterLink, useLocation } from 'react-router-dom';

import { Span } from 'common';

import { useSideNavigationAnimation } from '../Animation';
import { SIDEBAR_NAVIGATION_SX_MARGIN_X } from '../constants';
import { SideNavigationState, useSideNavigationModeContext } from '../context';

export function SidebarNavigationAgenticChatLink() {
  const { pathname } = useLocation();
  const { sideNavigationOpacityAnimation } = useSideNavigationAnimation();
  const { sideNavigationState } = useSideNavigationModeContext();

  return (
    <Stack marginX={SIDEBAR_NAVIGATION_SX_MARGIN_X} alignItems="flex-start">
      <Button
        component={ReactRouterLink}
        to="/chat"
        variant="text"
        color="inherit"
        startIcon={<SparkleIcon />}
        fullWidth
        sx={{
          justifyContent: 'flex-start',
          backgroundColor: pathname.startsWith('/chat') ? 'rgba(255, 255, 255, 0.2)' : undefined,
        }}
        tabIndex={sideNavigationState === SideNavigationState.Collapsed ? -1 : 0}
      >
        <Span sx={{ ...sideNavigationOpacityAnimation }}>Agentic chat</Span>
      </Button>
    </Stack>
  );
}
